<template>
  <div>
    <b-sidebar
        v-model="sidebarVisible"
        class="pbi-sidebar"
        id="sidebar-dashboard-menu"
        title="Dashboard"
        bg-variant="dark"
        text-variant="light"
        backdrop
    >
      <div>
        <tree-node :items="foldersWithReports" @selectedReport="selectedReport" :reports="reportsWithoutFolders"/>
      </div>
      <!--      <b-list-group class="list-group">-->
      <!--        <b-list-group-item class="list-group-item text-light bg-dark" to="#" v-for="(report, index) in reports"-->
      <!--                           :key="index" @click.prevent="loadReport(report)">-->
      <!--          <span>{{ report.title }}</span>-->
      <!--        </b-list-group-item>-->
      <!--      </b-list-group>-->
    </b-sidebar>
    <div style="height: calc(100vh - 64px)">
      <div class="side-menu d-inline-block p-2 align-top">
        <b-button-group vertical size="sm">
          <b-button
              variant="outline-secondary"
              :disabled="reportLoading"
              @click="sidebarVisible = !sidebarVisible"
          >
            {{ $route.query.name || 'Menu' }}
          </b-button>
          <b-button variant="outline-secondary" :disabled="!reportIsLoaded && reportLoading" @click="initiateExport">
            Export
          </b-button>
        </b-button-group>

      </div>
      <div class="report-container d-inline-block py-2">
        <div>
          <report ref="report" :embed-url="embedUrl" :token="token" @reportLoaded="handleReportLoaded"/>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Report from "../../components/reports/Report.vue";
import TreeNode from "../../components/reports/TreeNode.vue";
import _ from "lodash";
import tableauMenuServices from "../../services/tableauMenuServices";

export default {
  name: "Reports",
  components: {Report, TreeNode},
  async mounted() {
    await Promise.all([this.getReports(),this.getFolders(), this.getToken()]);
    if(this.$route.params.id) 
      this.selectedReport(this.$route.params.id)
  },
  computed: {
    reportsWithoutFolders() {
      return _.filter(this.reports, (r) => {
        return r.tableauMenuFolderId === null
      })
    },
    foldersWithReports() {
      let arr = _.cloneDeep(this.folders);
      let reports = _.cloneDeep(this.reports);
      arr = _.orderBy(arr, ['parentId', 'title'])
      if (arr.length) {
        _.forEach(arr, folder => {
          folder.reports = _.filter(reports, report => {
            return report.tableauMenuFolderId === folder.tableauMenuFolderId
          });
        });
        return buildTree(arr);
      }


      return [];
    },

  },
  data() {
    return {
      sidebarVisible: true,
      reports: [],
      embedUrl: '',
      token: '',
      reportLoading: false,
      folders: [],

      reportIsLoaded: false,
    }
  },
  watch: {
  '$route.params.id'(id, oldId) {
    if(id && id !== oldId)
      this.selectedReport(id)
    }
  },
  methods: {
    async getReports() {
      const response = await tableauMenuServices.getReports();
      if (response.data) {
        this.reports = response.data;
      }
    },
    async getFolders() {
      const response = await tableauMenuServices.getFolders();
      if (response.data) {
        this.folders = response.data;
      }
    },
    async getToken() {
      const response = await tableauMenuServices.getToken();
      if (response.data) {
        this.token = response.data;
      }
    },
    selectedReport(id) {
      if(isNaN(id)) 
        return;

      const report = _.find(this.reports, {tableauMenuConfigId: Number(id)});
      this.loadReport(report);
    },
    async loadReport({embedUrl}) {
      if (embedUrl !== this.embedUrl) {
        await this.getToken();
        this.sidebarVisible = false;
        this.embedUrl = embedUrl;
        this.reportLoading = true;
      }
    },
    handleReportLoaded() {
      this.reportLoading = false;
      this.reportIsLoaded = true;
    },
    initiateExport() {
      this.$refs.report.initiateExport();
    }
  }
}

const buildTree = (arr, parentId = null) => {
  const result = [];

  arr.forEach(item => {
    if (item.parentId === parentId) {
      const children = buildTree(arr, item.tableauMenuFolderId);
      if (children.length) {
        item.children = children;
      }
      result.push(item);
    }
  });

  return result;
}
</script>


<style scoped>
.list-group {
  padding: 0;
  overflow: hidden;
}

.list-group-item {
  border-radius: 0;
  border-width: 1px 0 0 0;
  padding: 0.2em 1em;
  cursor: pointer;
}

.list-group > .list-group-item:first-child {
  border-top-width: 0;
}

.child-list .list-group-item {
  text-indent: 1em;
}

.side-menu {
  width: 100px;
}

.report-container {
  width: calc(100% - 100px)
}
</style>